<template>
  <v-container grid-list-sm>
    <v-layout>
      <v-flex>
        <v-card :color="$store.state.sysBackgroundColor">
          <EncabezadoProceso
            :titulo="iTitulo"
            :accion="accion"
            @ejecutarAccion="ejecutarAccion"
          />
          <v-card-text>
            <v-form ref="form">
              <v-layout row wrap>
                <v-flex xs12 md6>
                  <small>Cerrando Turno</small><br />
                  <span class="button">
                    {{ iTurnoActual }}
                  </span>
                </v-flex>
                <v-flex xs6 md3>
                  <small>Abriendo Turno</small><br />
                  <span class="button">
                    {{ iTurnoSiguiente }}
                  </span>
                </v-flex>
                <v-flex xs6 md3>
                  <SelectEmpleado
                    :model="itemActivo.Id_EmpleadoSiguiente"
                    :rules="[rules.requerido]"
                    @seleccionarItem="
                      item =>
                        (itemActivo.Id_EmpleadoSiguiente = item.Id_Empleado)
                    "
                  />
                </v-flex>
              </v-layout>
            </v-form>
          </v-card-text>
          <PieCrud :loading="loading" />
        </v-card>
      </v-flex>
    </v-layout>
    <Mensaje
      :activo="mensajeActivo"
      :tipo="mensajeTipo"
      :titulo="mensajeTitulo"
      :detalle="mensajeDetalle"
      @ejecutarAccion="ejecutarAccion"
    />
  </v-container>
</template>

<script>
import HttpHelper from "@/store/HttpHelper";
import moment from "moment";
import EncabezadoProceso from "@/components/EncabezadoProceso";
import PieCrud from "@/components/PieCrud";
import Mensaje from "@/components/Mensaje";
import SelectEmpleado from "@/components/Personal/SelectEmpleado";
export default {
  name: "CajaPosCorte",
  components: {
    EncabezadoProceso,
    PieCrud,
    Mensaje,
    SelectEmpleado
  },
  data() {
    return {
      titulo: "Corte de Turno",
      itemVacio: {
        Id_Caja: 0,
        Id_PuntoVenta: 0,
        NombrePuntoVenta: "",
        Fecha: "",
        Turno: 0,
        Id_Empleado: 0,
        NombreEmpleado: "",
        FechaSiguiente: "",
        TurnoSiguiente: 0,
        Id_EmpleadoSiguiente: 0
      },
      itemActivo: {},
      rules: {
        requerido: v => !!v || "Requerido"
      },
      loading: false,
      mensajeActivo: false,
      mensajeTipo: "",
      mensajeTitulo: "",
      mensajeDetalle: "",
      controlSoloLectura: true,
      accion: "",
      tabs: "tab1"
    };
  },
  computed: {
    appId_PuntoVenta() {
      return this.$store.state.appId_PuntoVenta;
    },
    iTitulo() {
      return this.itemActivo.NombrePuntoVenta
        ? this.titulo + " " + this.itemActivo.NombrePuntoVenta
        : this.titulo;
    },
    iTurnoActual() {
      return this.itemActivo.Fecha
        ? moment(this.itemActivo.Fecha)
            .locale("es-AR")
            .format("L") +
            " - " +
            this.itemActivo.Turno +
            " (" +
            (this.itemActivo.NombreEmpleado
              ? this.itemActivo.NombreEmpleado
              : "") +
            ")"
        : "";
    },
    iTurnoSiguiente() {
      return this.itemActivo.FechaSiguiente
        ? moment(this.itemActivo.FechaSiguiente)
            .locale("es-AR")
            .format("L") +
            " - " +
            this.itemActivo.TurnoSiguiente
        : "";
    },
    iEmpleado() {
      return "...";
    }
  },
  mounted() {
    this.itemActivo = Object.assign({}, this.itemVacio);
    this.inicializar();
  },
  methods: {
    ejecutarAccion(accion) {
      this.accion = accion;
      switch (accion) {
        case "Ejecutar":
          if (this.$refs.form.validate())
            this.mostrarMensaje(true, "ConfirmacionGuardar", null, null);
          break;
        case "AceptarConfirmacionGuardar":
          this.guardarItem(this.itemActivo);
          break;
        case "CancelarConfirmacionGuardar":
          this.mostrarMensaje(false);
          break;
        case "CancelarError":
        case "Finalizar":
          this.mostrarMensaje(false);
          this.$router.go(-1);
          break;
        case "Inicializar":
          this.$refs.form.resetValidation();
          this.inicializar();
          break;
      }
    },
    inicializar() {
      HttpHelper.get("Caja/BuscarTurnoCortado", {
        id_PuntoVenta: this.appId_PuntoVenta
      })
        .then(response => {
          if (response.data.Resultado == "NO EXISTE") this.buscarTurnoActual();
          else
            this.mostrarMensaje(
              true,
              "Error",
              "Turno Cortado",
              "Debe realizar el cierre de turno Nº " +
                moment(response.data.Fecha)
                  .locale("es-AR")
                  .format("L") +
                "-" +
                response.data.Turno +
                " para continuar."
            );
        })
        .catch(error => {
          this.mostrarError(error);
        });
    },
    buscarTurnoActual() {
      HttpHelper.get("Caja/BuscarTurnoActual", {
        id_PuntoVenta: this.appId_PuntoVenta
      })
        .then(response => {
          if (response.data.Resultado == "OK") {
            this.itemActivo.Id_Caja = response.data.Id_Caja;
            this.itemActivo.Id_PuntoVenta = response.data.Id_PuntoVenta;
            this.itemActivo.NombrePuntoVenta = response.data.NombrePuntoVenta;
            this.itemActivo.Fecha = response.data.Fecha;
            this.itemActivo.Turno = response.data.Turno;
            this.itemActivo.Id_Empleado = response.data.Id_Empleado;
            this.itemActivo.NombreEmpleado = response.data.NombreEmpleado;
            this.calcularTurnoSiguiente();
          }
        })
        .catch(error => {
          this.mostrarError(error);
        });
    },
    calcularTurnoSiguiente() {
      HttpHelper.get("Caja/CalcularTurnoSiguiente", {
        id_PuntoVenta: this.appId_PuntoVenta
      })
        .then(response => {
          this.itemActivo.FechaSiguiente = response.data.Fecha;
          this.itemActivo.TurnoSiguiente = response.data.Turno;
        })
        .catch(error => {
          this.mostrarError(error);
        });
    },
    guardarItem(item) {
      this.loading = true;
      HttpHelper.post("Caja/CortarTurno", item)
        .then(() => {
          this.abrirTurno();
        })
        .catch(error => {
          this.mostrarError(error);
        });
    },
    abrirTurno() {
      HttpHelper.post("Caja/AbrirTurno", {
        Id_PuntoVenta: this.itemActivo.Id_PuntoVenta,
        Fecha: this.itemActivo.FechaSiguiente,
        Turno: this.itemActivo.TurnoSiguiente,
        Id_Empleado: this.itemActivo.Id_EmpleadoSiguiente
      })
        .then(() => {
          this.ejecutarAccion("Finalizar");
          this.loading = false;
        })
        .catch(error => {
          this.mostrarError(error);
        });
    },
    mostrarError(error) {
      var detalle;
      detalle =
        error.response === undefined
          ? error
          : error.response.data.ExceptionMessage;
      this.mostrarMensaje(true, "Error", null, detalle);
    },
    mostrarMensaje(activo, tipo, titulo, detalle) {
      if (activo) {
        this.mensajeTipo = tipo;
        this.mensajeTitulo = titulo;
        this.mensajeDetalle = detalle;
      }
      this.mensajeActivo = activo;
    }
  }
};
</script>
